import React, { type ReactNode } from "react";

import clsx from "clsx";

import { formatting } from "@north-beam/nb-common";

export type TabId = "campaign" | "adset" | "ad";

interface Props {
  activeTab: TabId;
  campaignsCount: number;
  adsetsCount: number;
  adsCount: number;
  onActivate(tab: TabId): void;
}

export const Tabs = ({
  activeTab,
  campaignsCount,
  adsetsCount,
  adsCount,
  onActivate,
}: Props) => {
  return (
    <div className="flex gap-1 text-sm relative">
      <Tab
        active={activeTab === "campaign"}
        itemsCount={campaignsCount}
        onClick={() => onActivate("campaign")}
      >
        Campaigns
      </Tab>
      <Tab
        active={activeTab === "adset"}
        itemsCount={adsetsCount}
        onClick={() => onActivate("adset")}
      >
        Adsets
      </Tab>
      <Tab
        active={activeTab === "ad"}
        itemsCount={adsCount}
        onClick={() => onActivate("ad")}
      >
        Ads
      </Tab>
    </div>
  );
};

interface TabProps {
  children: ReactNode;
  active?: boolean;
  itemsCount: number;
  onClick(): void;
}

export const Tab = ({ children, active, itemsCount, onClick }: TabProps) => {
  return (
    <div
      onClick={onClick}
      className={clsx(
        "w-64 h-10 px-2.5 flex items-center cursor-pointer z-[2]",
        "border rounded-t-lg text-interstellar+2",
        {
          "bg-[#f8f8f9] border-gray-0 ": !active,
          "hover:border-t-primary hover:border-x-primary hover:bg-cosmic-4":
            !active,
          "bg-white border-t-gray-0 border-x-gray-0 border-b-white": active,
        },
      )}
    >
      <div
        className={clsx("flex-1 flex items-center justify-between", {
          "text-primary font-semibold": active,
        })}
      >
        <div>{children}</div>
        <div className="text-xxs text-interstellar bg-gray-2 font-normal py-1.5 px-3 rounded-xl">
          {formatting.formatInteger(itemsCount, { precision: "exact" })}
        </div>
      </div>
    </div>
  );
};
